import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=31878594&scoped=true"
import script from "./DropdownDivider.vue?vue&type=script&lang=ts"
export * from "./DropdownDivider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31878594",
  null
  
)

export default component.exports